<template lang="pug">
.AppChart
	.AppChart-Chart(
		ref="chartContainer"
	)
		chart.AppChart-Highchart(
			ref="highchart"
			constructor-type="stockChart"
			:options="chartOptions"
		)
		//- div.AppChart-PrintableSVG(
		//- 	ref="printableSVG"
		//- )

	//- slide-right-transition(:duration="800")
	//- state-legend.AppChart-Legend(
	//- 	v-if="selectedData"
	//- 	:data="selectedData"
	//- )
</template>

<script>
import $ from 'jquery';
import Highcharts from 'highcharts';
import 'highcharts/modules/stock';
import "highcharts/modules/exporting";
import "highcharts/modules/offline-exporting";

import { Chart } from 'highcharts-vue';

import { DATA_URI_LOGO, SVG_LOGO } from '@/pmms/js/constants';
import logoUrl from '@/pmms/images/freddie-mac-logo.png';

const shareDimensions = {
	facebook: [600, 315],
	twitter: [600, 300],
	instagram: [540, 540]
};

const sharePopupDimensions = {
	facebook: [600, 500],
	twitter: [500, 500]
};

const colors = ['#4CA9E9', '#88B345', '#DB691E'];

Highcharts.AST.allowedReferences.push('data:');

const replaceLast = (str, pattern, replacement) => {
	const match =
		typeof pattern === 'string'
			? pattern
			: (str.match(new RegExp(pattern.source, 'g')) || []).slice(-1)[0];
	if (!match) return str;
	const last = str.lastIndexOf(match);
	return last !== -1
		? `${str.slice(0, last)}${replacement}${str.slice(last + match.length)}`
		: str;
};

Highcharts.seriesType('plotband', 'column', {
	lineWidth: 0,
	threshold: null
}, {
	/*= if (build.classic) { =*/
	// mapping between SVG attributes and the corresponding options
	pointAttrToOptions: {
		fill: 'color',
		stroke: 'lineColor',
		'stroke-width': 'lineWidth'
	},
	/*= } =*/
	animate: function () { },

	translate: function () {
		var series = this,
			xAxis = series.xAxis,
			yAxis = series.yAxis;

		Highcharts.Series.prototype.translate.apply(series);

		series.points.forEach(function (point) {
			var onXAxis = point.onXAxis,
				ownAxis = onXAxis ? xAxis : yAxis,
				otherAxis = onXAxis ? yAxis : xAxis,
				from = ownAxis.toPixels(point.from, true),
				to = ownAxis.toPixels(point.to, true),
				start = Math.min(from, to),
				width = Math.abs(to - from);

			point.plotY = 1; // lure ColumnSeries.drawPoints
			point.shapeType = 'rect';
			point.shapeArgs = ownAxis.horiz ? {
				x: start,
				y: 0,
				width: width,
				height: otherAxis.len
			} : {
				x: 0,
				y: start,
				width: otherAxis.len,
				height: width
			};
		});
	}
});

export default {
	name: 'AppChart',

	props: {
		seriesData: {
			type: Object
		},
		lastUpdated: {
		}
	},

	components: {
		Chart
	},

	data() {
		const series = [{
			"name": "30Y FRM",
			"title": "30-Yr FRM",
			"showInNavigator": true,
			"data": this.seriesData.rate30
		}, {
			"name": "15Y FRM",
			"title": "15-Yr FRM",
			"data": this.seriesData.rate15
		}];

		series.forEach((s, i) => {
			s.data[s.data.length - 1].dataLabels = {
				enabled: true,
				align: 'left',
				x: 3,
				verticalAlign: 'middle',
				overflow: true,
				useHTML: false,
				crop: false,
				allowOverlap: true,
				tooltip: {
					shared: true
				},
				style: {
					'color': colors[i],
					'fontSize': '16px',
					'fontWeight': '600'
				},
				formatter: function () {
					var isLast = false;
					if (!this.series) return;
					if (!this.series.visible) return;
					if (this.series.chart.options.legend.enabled) return;
					if (this.point.x === this.series.data[this.series.data.length - 1].x && this.point.y === this.series.data[this.series.data.length - 1].y) isLast = true;
					return isLast ? this.y + '%' : '';
				}
			};
		});

		series.push({
			type: 'plotband',
			name: 'Recessions',
			zIndex: -1,
			borderWidth: 0,
			lineWidth: 0,
			tooltip: false,
			enableMouseTracking: false,
			color: 'rgba( 0, 0, 0, 0.08)',
			data: [{
				from: Date.UTC(1973, 11),
				to: Date.UTC(1975, 3),
				onXAxis: true,
			}, {
				from: Date.UTC(1980, 1),
				to: Date.UTC(1980, 7),
				onXAxis: true,
			}, {
				from: Date.UTC(1981, 7),
				to: Date.UTC(1982, 11),
				onXAxis: true,
			}, {
				from: Date.UTC(1990, 6),
				to: Date.UTC(1991, 4),
				onXAxis: true,
			}, {
				from: Date.UTC(2007, 11),
				to: Date.UTC(2009, 5),
				onXAxis: true,
			}, {
				from: Date.UTC(2001, 2),
				to: Date.UTC(2001, 10),
				onXAxis: true,
			}, {
				from: Date.UTC(2020, 2),
				to: Date.UTC(2020, 3),
				onXAxis: true,
			}]
		});


		return {
			chart: null,
			seriesMap: {},
			pointsData: [],
			chartOptions: {
				colors,
				chart: {
					//marginLeft: 0,
					marginRight: 0,
					zooming: {
						mouseWheel: {
							enabled: false
						}
					},
					events: {
						// afterPrint: $.proxy(this.onResize, this)
						load: e => {
							this.onChartLoad(e);
							this.setLineWidth(e);
						}
					},
					style: {
						fontFamily: 'canada-type-gibson'
					}
				},

				title: {
					enabled: false
				},

				credits: {
					enabled: false
				},

				navigator: {
					maskFill: 'rgba(0,165,229,0.2)',
					series: {
						color: '#00A5E5',
						fillOpacity: '0.15'
					}
				},

				navigation: {
					buttonOptions: false
				},

				exporting: {
					
					sourceWidth: shareDimensions.facebook[0] * 1,
					sourceHeight: shareDimensions.facebook[1] * 1,

					buttons: {
						contextButton: {
							enabled: false
						}
					},
					chartOptions: {
						rangeSelector: {
							enabled: false
						},
						navigator: {
							enabled: false
						},
						scrollbar: {
							enabled: false
						},
						legend: {
							enabled: false
						},
						title: {
							x: 200,
							y: 20,
							useHTML: true,
							text: 'Primary Mortgage Market Survey®',
							style: {
								fontSize: '18px',
								fontWeight: 500
							},
							align: 'left'
						},

						subtitle: {
							text: 'U.S. weekly average mortgage rates as of LAST_UPDATED',
							x: 200,
							y: 39.5,
							align: 'left',
							useHTML: true,
							style: {
								fontSize: '13px',
								fontWeight: '400'
							}
						},

						chart: {
							marginRight: 65,
							marginTop: 60,
							style: {
								fontFamily: 'canada-type-gibson'
							},
							events: {
								render: $.proxy(function (e) {
									this.setLineWidth(e);
									this.onRender(e);
								}, this)
							},
							animation: {
								complete: $.proxy(this.onRender, this)
								//step : $.proxy( this.onRender, this )
							}
						}
					},
					formAttributes: {
						width: shareDimensions.facebook[0],
						height: shareDimensions.facebook[1]
					}
				},

				rangeSelector: {
					enabled: false,
					inputEnabled: false,
					inputPosition: {
						align: 'right'
					},
					buttons: {
						enabled: false
					}
				},

				legend: {
					enabled: true
				},

				xAxis: {
					events: {
						setExtremes: $.proxy(this.onSetExtremes, this),
						afterSetExtremes: $.proxy(function (e) {
							this.setLineWidth(e);
							this.onSetExtremes(e);
						}, this)
					},

				},

				yAxis: {
					labels: {
						format: '{value:.2f}%'
					},
					lineWidth: 1,
					opposite: false,
					plotLines: [{
						value: 0,
						width: 2,
						color: 'silver'
					}],
					minTickInterval: 0.25
				},

				plotOptions: {
					series: {
						// turboThreshold: this.turboThreshold,
						turboThreshold: Math.max(this.seriesData.rate30.length, this.seriesData.rate15.length),
						showInNavigator: false,
						lineWidth: 1,
						dataGrouping: {
							enabled: false
						},
						dataLabels: {
							allowOverlap: true
						}
					}
				},

				tooltip: {
					valueDecimals: 2,
					backgroundColor: '#fff',
					shared: true,
					useHTML: true,
					xDateFormat: 'Week ending %A, %b %e, %Y',
					headerFormat: '<div style="font-family: canada-type-gibson; font-size: 14px; font-weight: bold; margin-bottom: 0.25em; display: block; color: #464645;">{point.key}</div><table style="font-family:canada-type-gibson; font-size: 1.8em; font-weight: 500;">',
					pointFormat: '<tr><th><span style="color:{series.color}; font-weight: 500;  font-size: 15px;">{series.name}:</span></th><td><span style="padding-left: 4px; font-size: 15px; font-weight: 600;">{point.y}%</span></td></tr>',
					footerFormat: '</table>'
				},

				responsive: {
					rules: [{
						condition: {
							maxWidth: 460
						},
						chartOptions: {
							rangeSelector: {
								inputEnabled: false
							}
						}
					}]
				},

				series
			}
		}
	},

	computed: {

	},

	mounted() {
		if (this.chart && this.data) {
			// this.loadData();

		}
	},

	watch: {

	},

	methods: {

		onChartLoad(e) {
			if (!this.chart) {
				this.chart = e.target;

				let old = this.chart.getSVGForExport;

				// <link href="https://use.typekit.net/izj2zwr.css" rel="stylesheet" />
				const rules = [
					'@import url("https://use.typekit.net/izj2zwr.css");'
				];
				for (let i = 0; i < document.styleSheets.length; i++) {
					const sheet = document.styleSheets[i];
					try {
						for (let j = 0; j < sheet.cssRules.length; j++) {
							let rule = sheet.cssRules[j];
							if (rule.cssText.match(/\.AppChart-Chart/)) {

								rules.push(
									rule.cssText.replace(/\.AppChart-Chart/gim, '')
								);
							}
						}
					} catch (e) {

					}
				}

				const styles = rules.join("\n");
				const lastUpdated = this.lastUpdated;

				// this.chart.getSVGForExport = function () {
					
					// var isInstagram = this.exporting.sourceHeight == 540;
					// var args = Array.prototype.slice.call(arguments, 0);

					// if (isInstagram) {
					// 	args[0].title.x = 152;
					// 	args[0].title.y -= 5;
					// 	args[0].subtitle.x = 152;
					// 	args[0].subtitle.y -= 5;
					// }
					// var svg = old.apply(this, args);
					// var $svg = $(svg);
					// var $style = $('<style type="text/css" />').html(styles);

					// // change the viewbox and size of svg
					// $style.prependTo($svg);

					// var img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
					// img.setAttributeNS(null, 'height', isInstagram ? 32 : 40);
					// img.setAttributeNS(null, 'width', isInstagram ? 138 : 173);
					// img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', DATA_URI_LOGO);
					// img.setAttributeNS(null, 'x', isInstagram ? 10 : 15);
					// img.setAttributeNS(null, 'y', isInstagram ? 12 : 10);

					// $svg.append(img);

					// var rendered = $svg[0].outerHTML;
					// rendered = replaceLast( rendered, '®', '<tspan style="font-size: 10px;" baseline-shift="super">®</tspan>');
					// rendered = rendered.replace(/LAST_UPDATED/, ' ' + lastUpdated);
					// return rendered;

				// }

				// lets hook into the getSVGForLocalExport
				Highcharts.wrap( this.chart, 'getSVG', function (proceed, options) {

					

					
					const isInstagram = options.exporting.sourceHeight == 540;
					const w = isInstagram ? 138 : 173;
					const h = isInstagram ? 32 : 40;
					const x = isInstagram ? 10 : 15;
					const y = isInstagram ? 12 : 10;

					
					// add image through chart renderer
					// this.renderer.image(logoUrl, x, y, w, h).add();

					let svg = proceed(options);

					// const img = `<image xlink:href="${DATA_URI_LOGO}" x="${x}" y="${y}" width="${w}" height="${h}" />`;
					// svg = svg.replace(/<\/svg>/, img + '</svg>');

					const logo = SVG_LOGO.replace('<svg', '<svg width="' + w + '" height="' + h + '" x="' + x + '" y="' + y + '"');

					svg = svg.replace(/<\/svg>/, logo + '</svg>');
					svg = svg.replace(/<\/svg>/, '<style>' + styles.replace(/\s+/gs, ' ') + '</style></svg>')
					svg = svg.replace(/LAST_UPDATED/, ' ' + lastUpdated);
					svg = replaceLast( svg, '®', '<tspan style="font-size: 10px;" baseline-shift="super">®</tspan>');
					return svg;
				});

				this.$emit('chart', this.chart);
			}
		},

		setLineWidth: function (e) {

			if (this.chart) {
				var chart = this.chart;

				var extremes = chart.xAxis[0].getExtremes();
				var year = 1000 * 60 * 60 * 24 * 365;
				var diff = extremes.max - extremes.min;
				var group = $(chart.container).find('.highcharts-series-group')[0];
				var className = group.getAttribute('class');
				className = className.replace(/(^|\s)line-width[^\s]+/, '');
				group.setAttribute('class', className);
				var lineWidth = 4;
				if (diff > 20 * year) {
					group.setAttribute('class', className + " line-width-1");
				}
				else if (diff > 10 * year) {
					group.setAttribute('class', className + " line-width-2");
				}
				else if (diff > 3 * year) {
					group.setAttribute('class', className + " line-width-3");
				}
			}
		},

		onSetExtremes: function () {
			if (!this.chart || !this.chart.xAxis) return;
			if (this.settingRange) return;
			var extremes = this.chart.xAxis[0].getExtremes();
			var min = new Date(), max = new Date();
			min.setTime(extremes.min);
			max.setTime(extremes.max);
			this.$emit('rangechange', [min, max]);
		},

		onRender: function (e) {
			
			let last = null;
			let series = !!e && e.target && e.target.series ? e.target.series : this.chart.series;
			const labels = [];
			series.sort(function (a, b) {
				return a.data[a.data.length - 1].y > b.data[b.data.length - 1].y ?
					-1 : 1;
			});
			if (series) $.each(series, function (i, s) {

				if (!s.dataLabelsGroup || !s.dataLabelsGroup.element) {
					return;
				}
				// lets get in there and add the title below the label
				var el = s.dataLabelsGroup.element;

				var $t = $(el).find('text');
				var $g = $(el).find('>g');

				// remove the outline 
				$(el).find('.highcharts-text-outline').remove();;

				if (!$t.length) {
					return;
				}

				if (!$(el).find('[class="fm-series-label"]').length) {

					// create a new tspan
					var tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
					tspan.textContent = s.name;
					tspan.setAttributeNS(null, 'x', $t[0].getAttributeNS(null, 'x'));
					//tspan.setAttributeNS( null, 'y', Number( $t[0].getAttributeNS( null, 'y' ) ) + $t[0].getBBox().height - 4 );
					// Hard because the values for the BBox vary per browser
					tspan.setAttributeNS(null, 'y', 34);
					tspan.setAttributeNS(null, 'class', 'fm-series-label');
					$(tspan).css({
						"font-size": '11px'
					});
					$t.append(tspan);
				}

				var BBox = el.getBBox();

				var transform = $g[0].getAttributeNS(null, 'transform');
				var y = s.data[s.data.length - 1].plotY - BBox.height / 2 - 10;

				if (y <= last) {
					y = last;
				}


				$g[0].setAttributeNS(null, 'transform', transform.replace(/\((\-?\d+)([\,\s]+)(\-?[\.\d]+)\)/, '($1$2' + (y || 0) + ')'));
				labels.push({ $g: $g, BBox: BBox, y: y });

				last = y + BBox.height + 10;

				// what if this extends beyone the bottom of the chart...

			});

			var bottom = e.target.plotBox.height;

			var offset = last - bottom;

			if (last > bottom) {

				$.each(labels.reverse(), function (i, label) {
					var y = label.y - offset;
					var transform = label.$g[0].getAttributeNS(null, 'transform');
					var replaced = transform.replace(/\((\-?\d+)([\,\s]+)(\-?[\.\d]+)\)/, '($1$2' + y + ')');

					label.$g[0].setAttributeNS(null, 'transform', replaced);

					// check to see if there is another one after this...
					if (labels[i + 1]) {
						if (labels[i + 1].BBox.height + 10 + labels[i + 1].y > y) {
							offset = (labels[i + 1].BBox.height + 10 + labels[i + 1].y) - y;
						}
						else {
							return false;
						}
					}
				});
			}
			
		},

	}

};
</script>

<style lang="scss">
.AppChart-Highchart {
	height: 500px;
}

.AppChart-Chart .highcharts-container {
	overflow: visible !important;
	height: 500px;
}

.AppChart-Chart .highcharts-plot-background {
	fill: #fafafa;
}

.AppChart-Chart .highcharts-null-point {
	fill: #000;
	opacity: 0.1;
}

.AppChart-Chart .highcharts-series-inactive.highcharts-line-series {
	opacity: 1;
}

.AppChart-Chart .highcharts-plotband-series {
	opacity: 1 !important;
}

.AppChart-Chart .highcharts-root tspan {
	font-family: canada-type-gibson, "Lucida Grande";
}

.AppChart-Chart .highcharts-line-series .highcharts-graph {
	stroke-width: 3px;
	transition: 0.2s stroke-width;
}

.AppChart-Chart .highcharts-line-series.highcharts-series-hover .highcharts-graph {
	stroke-width: 4px;
}

.AppChart-Chart .highcharts-series-group.line-width-3 .highcharts-line-series .highcharts-graph {
	stroke-width: 2px;
}

.AppChart-Chart .highcharts-series-group.line-width-3 .highcharts-line-series.highcharts-series-hover .highcharts-graph {
	stroke-width: 3px;
}

.AppChart-Chart .highcharts-series-group.line-width-2 .highcharts-line-series .highcharts-graph {
	stroke-width: 1px;
}

.AppChart-Chart .highcharts-series-group.line-width-2 .highcharts-line-series.highcharts-series-hover .highcharts-graph {
	stroke-width: 2px;
}

.AppChart-Chart .highcharts-series-group.line-width-1 .highcharts-line-series .highcharts-graph {
	stroke-width: 1px;
}

.AppChart-Chart .highcharts-series-group.line-width-1 .highcharts-line-series.highcharts-series-hover .highcharts-graph {
	stroke-width: 2px;
}

.AppChart-Chart .highcharts-navigator-series .highcharts-area {
	fill: #00A5E5;
}

.AppChart-Chart .highcharts-navigator-series .highcharts-graph {
	stroke: #00A5E5;
}

.AppChart-Chart .highcharts-axis-labels {
	font-weight: 600;
}
</style>
